document.addEventListener("DOMContentLoaded", () => {

    const selectors = document.querySelectorAll(".routine-selector");

    selectors.forEach(selector => {

        const tabs = selector.querySelectorAll(".routine-tab");
        const panels = selector.querySelectorAll(".routine-panel");

        tabs.forEach(tab => {

            tab.addEventListener("click", () => {

                const target = tab.dataset.routine;

                tabs.forEach(item => item.classList.remove("active"));
                panels.forEach(panel => panel.classList.remove("active"));

                tab.classList.add("active");

                const panel = selector.querySelector(
                    `.routine-panel[data-content="${target}"]`
                );

                if (panel) {
                    panel.classList.add("active");
                }

            });

        });

    });

});